import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import { getDashboardExternalPageExtensionPath } from '@wix/cli-astro-definitions';
import { isStandaloneExtensionsProject } from '@wix/cli-custom-extensions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const DASHBOARD_EXTERNAL_PAGE_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-external-page'
);

export async function generateDashboardExternalPage(
  projectFolder: string,
  name: string,
  url: string
) {
  const cwd = getDashboardExternalPageExtensionPath(projectFolder, name);
  const { relativePathToConfigFile } = getExtensionRelativePaths({
    cwd,
    projectFolder,
    extensionFileName: name,
    codeFileType: 'ts',
  });

  const config = {
    id: randomUUID(),
    url,
    embedded: false,
  };
  const isCustomExtensionsProject =
    await isStandaloneExtensionsProject(projectFolder);

  const genResult = await componentGenerator({
    template: DASHBOARD_EXTERNAL_PAGE_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      builderPackage: isCustomExtensionsProject
        ? '@wix/custom-extensions'
        : '@wix/astro/builders',

      name,
      config,
    },
  });

  await modifyExtensionsEntry({
    projectFolder,
    extensionName: camelCase(name),
    relativePath: relativePathToConfigFile,
    isCustomExtensionsProject,
  });

  return genResult;
}
